// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1LAMy","content":"LoadingAlert_content__3Pm_1"};